// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3eRmm","selects":"Documents_selects__3RzCk"};